// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__kVbwR","box":"styles_box__0g_he","icon":"styles_icon__tq_vW"};